import { render, staticRenderFns } from "./CollectionShare.vue?vue&type=template&id=31232514&scoped=true"
import script from "./CollectionShare.vue?vue&type=script&lang=js"
export * from "./CollectionShare.vue?vue&type=script&lang=js"
import style0 from "./CollectionShare.vue?vue&type=style&index=0&id=31232514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31232514",
  null
  
)

export default component.exports